import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = (theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  boxShadow: 24,
  backgroundColor: theme.palette.quizPopap.quizBg,
  width: { xs: "90%", sm: "90%", md: "90%" },
  maxHeight: "90vh",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
});

export const headerBoxStyle: SxProps<Theme> = {
  p: { xs: 2, sm: 4, md: 4 },
};

export const assessmentFinishHeaderStyle: SxProps<Theme> = {
  px: { xs: 2, sm: 4, md: 4 },
  pb: { xs: 2, sm: 4, md: 4 },
  pt: 0,
};

export const contentBoxStyle: SxProps<Theme> = {
  flex: 1,
  overflowY: "auto",
  px: { xs: 2, sm: 4, md: 6 },
  pb: 2,
};

export const footerBoxStyle: SxProps<Theme> = (theme) => ({
  p: 2,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  borderTop: `1px solid ${theme.palette.quizPopap.quizSeparator}`,
});

export const continueButtonStyle: SxProps<Theme> = {
  background: "linear-gradient(90deg, #28C9DC 0%, #8957CF 100%)",
  color: "#fff",
  borderRadius: "9999px",
  textTransform: "none",
  fontWeight: 600,
  px: 3,
  py: 1.5,
  "&:hover": {
    background: "linear-gradient(90deg, #28C9DC 0%, #8957CF 100%)",
    opacity: 0.9,
  },
};
